export function checkVideo(url: string) {
  const validExtensions = [
    ".mp4",
    ".avi",
    ".flv",
    ".wmv",
    ".webm",
    ".mov",
    ".mkv",
  ]
  if (
    validExtensions?.some((extension) => url?.toLowerCase()?.endsWith(extension))
  )
    return true
  else return false
}
